import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateWelcomeInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateWelcomeInfo = useCallback(
		(prevState, stream) => {
			const welcome = { ...prevState.welcome };
			if (stream['/brain/welcome_text']) {
				welcome.text = getStreamData(stream, '/brain/welcome_text');
			}
			return welcome;
		},
		[getStreamData],
	);

	return { updateWelcomeInfo };
};
